module.exports = __webpack_public_path__ + "img/popup-3.8f2b6b3b.webp";